import '../style/Hero.css';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="Hero" aria-label="Hero">
      <img
        className="Hero-bgImage"
        src={`${process.env.PUBLIC_URL}/image/tisa.jpeg`}
        alt=""
        loading="eager"
        aria-hidden="true"
      />
      <div className="Hero-overlay" aria-hidden="true" />

      <div className="Hero-inner">
        <motion.div
          className="Hero-copy"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          <p className="Hero-kicker">Expertise Delivered</p>
          <h1 className="Hero-title">
          Abstan Logistics is a trusted provider of seemless, efficient, 
          and innovative logistics solutions
          </h1>
          <p className="Hero-subtitle">
            We deliver seamless freight, customs, warehousing, and end-to-end
            logistics that keep your cargo moving efficiently—with professionalism,
            compliance, and risk-aware execution.
          </p>
          <div className="Hero-actions">
            <a className="Hero-cta" href="#services">
              Get Started
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
